// Hide Add to Cart buttons on free product pages
// This script hides the add to cart button when the product total is $0

class FreeProductButtonManager {
  constructor() {
    this.freeProductHandles = [
      'the-signature-crew-white-copy',
      'the-ultimate-long-sleeve-crew-neck-t-shirt-heather-heavy-metal-copy',
      'unisex-garment-dyed-crewneck-sweatshirt-copy'
    ];
    
    // Product display prices for free items
    this.freeProductPrices = {
      'the-signature-crew-white-copy': '$25',
      'the-ultimate-long-sleeve-crew-neck-t-shirt-heather-heavy-metal-copy': '$35',
      'unisex-garment-dyed-crewneck-sweatshirt-copy': '$70'
    };
    
    this.init();
  }
  
  init() {
    // Check if we're on a product page
    if (window.location.pathname.includes('/products/')) {
      this.checkAndHideButtons();
    }
  }
  
  checkAndHideButtons() {
    // Get the current product handle from the URL
    const pathParts = window.location.pathname.split('/');
    const productHandle = pathParts[pathParts.indexOf('products') + 1];
    
    if (this.freeProductHandles.includes(productHandle)) {
      this.hideAddToCartButtons();
    }
  }
  
  hideAddToCartButtons() {
    // Hide the add to cart button
    const addToCartButton = document.querySelector('add-to-cart-component button[type="submit"]');
    if (addToCartButton) {
      addToCartButton.style.display = 'none';
      console.log('FreeProductButtonManager - Hidden add to cart button for free product');
    }
    
    // Hide the quantity selector - try multiple selectors
    const quantitySelectors = [
      'quantity-selector-component',
      '.quantity-selector',
      '[class*="quantity"]',
      'quantity-selector-component.quantity-selector'
    ];
    
    quantitySelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        element.style.display = 'none';
        console.log(`FreeProductButtonManager - Hidden quantity selector using selector: ${selector}`);
      });
    });
    
    // Hide the variant picker form
    const variantPickerForm = document.querySelector('.variant-picker__form');
    if (variantPickerForm) {
      variantPickerForm.style.display = 'none';
      console.log('FreeProductButtonManager - Hidden variant picker form for free product');
    }
    
    // Hide the accelerated checkout buttons (Shop Pay, etc.)
    const acceleratedCheckoutBlock = document.querySelector('.accelerated-checkout-block');
    if (acceleratedCheckoutBlock) {
      acceleratedCheckoutBlock.style.display = 'none';
      console.log('FreeProductButtonManager - Hidden accelerated checkout buttons for free product');
    }
    
    // Also hide any shopify-payment-button elements
    const shopifyPaymentButtons = document.querySelectorAll('[data-shopify="payment-button"]');
    shopifyPaymentButtons.forEach(button => {
      button.style.display = 'none';
      console.log('FreeProductButtonManager - Hidden shopify payment button for free product');
    });
    
    // Add a message explaining this is a free product
    this.addFreeProductMessage();
  }
  
  addFreeProductMessage() {
    // Find the product form buttons container
    const buttonsContainer = document.querySelector('.product-form-buttons');
    if (buttonsContainer) {
      // Get current product handle to show specific offer
      const pathParts = window.location.pathname.split('/');
      const productHandle = pathParts[pathParts.indexOf('products') + 1];
      const displayPrice = this.freeProductPrices[productHandle] || '$0';
      
      // Create a message element
      const messageElement = document.createElement('div');
      messageElement.className = 'free-product-message';
      messageElement.innerHTML = `
        <div style="
          background-color: #f0f8f0;
          border: 1px solid #45851E;
          border-radius: 8px;
          padding: 16px;
          margin: 16px 0;
          text-align: center;
          color: #45851E;
          font-weight: 500;
        ">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style="margin-bottom: 8px;">
            <path d="M9 12L11 14L15 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 3 12 3 16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2"/>
          </svg>
          <p style="margin: 0; font-size: 16px;">
            This is a <strong>FREE</strong> product that will be automatically added to your cart when you qualify for our tiered offers!
          </p>
          <p style="margin: 8px 0 0 0; font-size: 14px; opacity: 0.8;">
            Spend $120+ to get this FREE T-Shirt • Spend $199+ to get this FREE SweatShirt
          </p>
          <p style="margin: 8px 0 0 0; font-size: 12px; opacity: 0.7;">
            Regular price: <span style="text-decoration: line-through;">${displayPrice}</span> • <strong>FREE</strong> with qualifying purchase
          </p>
        </div>
      `;
      
      // Insert the message before the buttons
      buttonsContainer.insertBefore(messageElement, buttonsContainer.firstChild);
    }
  }
}

// Initialize when DOM is loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new FreeProductButtonManager();
  });
} else {
  // DOM is already loaded
  new FreeProductButtonManager();
}
